import React from "react";

const MiniFlow = ({ width = "39", height = "35", style, className }) => (
  <svg
    width={width}
    height={height}
    style={style}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.21362 11.811H3.97802C2.42497 11.811 1.1543 10.5403 1.1543 8.9873V6.16357C1.1543 4.61052 2.42497 3.33984 3.97802 3.33984H8.21362C9.76667 3.33984 11.0373 4.61052 11.0373 6.16357V8.9873C11.0373 10.5403 9.76667 11.811 8.21362 11.811Z"
      stroke="#40E5A0"
      strokeWidth="1.69424"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6974 10.3994H22.6146C21.6828 10.3994 20.9204 9.63699 20.9204 8.70516V6.44621C20.9204 5.51438 21.6828 4.75195 22.6146 4.75195H27.6974C28.6292 4.75195 29.3916 5.51438 29.3916 6.44621V8.70516C29.3916 9.63699 28.6292 10.3994 27.6974 10.3994Z"
      stroke="#EFF1F5"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6974 20.9873H22.6146C21.6828 20.9873 20.9204 20.2249 20.9204 19.293V17.0341C20.9204 16.1023 21.6828 15.3398 22.6146 15.3398H27.6974C28.6292 15.3398 29.3916 16.1023 29.3916 17.0341V19.293C29.3916 20.2249 28.6292 20.9873 27.6974 20.9873Z"
      stroke="#EFF1F5"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0371 7.57422H20.9202"
      stroke="#7E858F"
      strokeWidth="0.752994"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.979 7.57422V25.9285C15.979 27.4815 17.2497 28.7522 18.8027 28.7522H20.9205"
      stroke="#7E858F"
      strokeWidth="0.752994"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.979 18.1641H20.9205"
      stroke="#7E858F"
      strokeWidth="0.752994"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6974 31.5771H22.6146C21.6828 31.5771 20.9204 30.8147 20.9204 29.8829V27.6239C20.9204 26.6921 21.6828 25.9297 22.6146 25.9297H27.6974C28.6292 25.9297 29.3916 26.6921 29.3916 27.6239V29.8829C29.3916 30.8147 28.6292 31.5771 27.6974 31.5771Z"
      stroke="#EFF1F5"
      strokeWidth="1.41186"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MiniFlow;
